import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

const Link = styled(RouterLink)`
  text-decoration: none;
  font-size: 17px;
  color: ${({ theme }) => theme.palette.hague};
  font-weight: 500;
`;

export { Link };
